import type { DateItem } from '@/types/date';

export const dayItems: Record<number, DateItem> = {
  0: {
    short: '日',
  },
  1: {
    short: '月',
  },
  2: {
    short: '火',
  },
  3: {
    short: '水',
  },
  4: {
    short: '木',
  },
  5: {
    short: '金',
  },
  6: {
    short: '土',
  },
};

export const getShortDay = ((dayNum: number) => dayItems[dayNum].short);

interface DateStringOptions {
  isDisplayDayShort: Boolean;
  isDisplayedTime?: Boolean;
};

export const getDateString = ((dateTime: Date, options: DateStringOptions = {
  isDisplayDayShort: true,
  isDisplayedTime: false,
}) => {
  let dateString: string = `${dateTime.getFullYear()}年${dateTime.getMonth() + 1}月${dateTime.getDate()}日（${getShortDay(dateTime.getDay())}）`;
  if (options.isDisplayedTime) {
    dateString += `${dateTime.getHours().toString().padStart(2, "0")}：${dateTime.getMinutes().toString().padStart(2, "0")}`;
  }
  return dateString;
});

export const getDateTimeString = ((dateTime1: Date, dateTime2: Date) => {
  let startDateTime: Date, endDateTime: Date;
  if ((dateTime2.getTime() - dateTime1.getTime()) / (60 * 60 * 24 * 1000) >= 0) {
    startDateTime = dateTime1; endDateTime = dateTime2;
  } else {
    startDateTime = dateTime2; endDateTime = dateTime1;
  }

  let dateRangeString: string = `${getDateString(startDateTime, {
    isDisplayDayShort: true,
    isDisplayedTime: true,
  })} ～ `;
  if (Math.floor(endDateTime.getDate() - startDateTime.getDate()) > 0) {
    dateRangeString += getDateString(endDateTime, {
      isDisplayDayShort: true,
      isDisplayedTime: true,
    });
  } else {
    dateRangeString += ` ${endDateTime.getHours().toString().padStart(2, "0")}：${endDateTime.getMinutes().toString().padStart(2, "0")}`;
  }
  return dateRangeString;
});

export const formatDateWithTimezone = ((date: Date, timeZone: string = 'Asia/Tokyo') => {
  const formatter: Intl.DateTimeFormat = new Intl.DateTimeFormat('en-US', {
    timeZone,
    year: 'numeric',
    month: '2-digit',
    day: '2-digit',
    hour: '2-digit',
    minute: '2-digit',
    hour12: false,
  });

  const parts: Intl.DateTimeFormatPart[] = formatter.formatToParts(date);

  const getPart = ((type: string) => parts.find(p => p.type === type)?.value);
  const yyyy = getPart('year'),
          mm = getPart('month'),
          dd = getPart('day'),
          hh = getPart('hour'),
         min = getPart('minute');

  // タイムゾーンオフセット（+09:00）を計算
  const utcDate = new Date(date.toLocaleString('en-US', { timeZone: 'UTC' }));
  const localeDate = new Date(date.toLocaleString('en-US', { timeZone }));
  const offsetMin = Math.round((localeDate.getTime() - utcDate.getTime()) / (60 * 1000));
  const sign = offsetMin >= 0 ? '+' : '-';
  const absMin = Math.abs(offsetMin);
  const offsetHH = (Math.floor(absMin / 60)).toString().padStart(2, '0');
  const offsetMM = (absMin % 60).toString().padStart(2, '0');

  return `${yyyy}-${mm}-${dd}T${hh}:${min}${sign}${offsetHH}:${offsetMM}`;
});
